import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
    return (
        <Sonner
            theme="dark"
            className="toaster group"
            style={
                {
                    "--normal-bg": "#232b3a",
                    "--normal-text": "rgb(255 255 255)",
                    "--normal-border": "white",
                    "--success-bg": "#232b3a",
                    "--success-text": "rgb(255 255 255)",
                    "--success-border": "white",
                    "--error-bg": "#232b3a",
                    "--error-text": "rgb(255 255 255)",
                    "--error-border": "white",
                    "--warning-bg": "#232b3a",
                    "--warning-text": "rgb(255 255 255)",
                    "--warning-border": "white",
                    "--info-bg": "#232b3a",
                    "--info-text": "rgb(255 255 255)",
                    "--info-border": "white",
                } as React.CSSProperties
            }
            {...props}
        />
    );
};
export { Toaster };
